import React, {useContext, useState} from 'react'
import {appContext} from '../contexts'
import {CONTACT} from '../fn'
import * as validator from 'email-validator'
import {TextInput, TextAreaInput} from './Inputs'
// import {useHeaderChecker, CONTACT_MODE} from './fn'

const Success = () => {
    return (
        <div className="success">
            <h1>Your message has been sent! Expect a response within a few days.</h1>
        </div>  
    )
}

const Error = ({status, fields}) => {
    const Name = props => {
        if(props.children.length < 1){
            return <h1>Please include a name.</h1>
        }
        return null
    }
    const Email = props => {
        if(!validator.validate(props.children)){
            return <h1>Please include a valid email.</h1>
        }
        return null
    }
    const Message = props => {
        if(props.children.length < 1){
            return <h1>Please include a message.</h1>
        }
        return null
    }
    console.log(fields)
    switch (status){
        case 400: return (
            <div className="error">
                <Name>{fields.name}</Name>
                <Email>{fields.email}</Email>
                <Message>{fields.message}</Message>
            </div>
        );
        default: return(
            <div className="error">
                <h1>{`Uh oh. Looks like this form isn't working right now. Try getting in touch via twitter or facebook.`}</h1>
            </div>
        ) 
    }
    
}

const Button = props => {
    return(
        <div className="button" onClick={props.handleSubmit}>
            <h2>SUBMIT</h2>
        </div>
    )
}

const Submit = props => {
    // 200 - everything is OK but nothing is loading
    const [status, setStatus] = useState(200);
    const {name, email, message} = props.data;

    const submitData = () => {
        return fetch('/api', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }, 
            body: JSON.stringify({name, email, message})
        }).then(res => {
            return res.status
        })
    }
    const submit = () =>{
        // 100 - everything is OK so far (i.e. loading)
        setStatus(100);
        if((name.length > 0 && message.length > 0) && validator.validate(email)){
            console.log("we're all good")
            submitData().then(res => {
                    if(res === 202){
                        props.handleReset();
                    }
                    setStatus(res);
            }).catch(err => {
                setStatus(err)
            })
        }else{
            console.log("something is wrong")
            // 400 - Improper request (e.g. something is missing or invalid in the form)
            setStatus(400);
        }
    }

    switch (status){
        case 100: return(
            <React.Fragment>
                <Button loading={true} handleSubmit={submit}/>
            </React.Fragment>
        );
        case 200: return(
            <Button handleSubmit={submit} />
        );
        case 202: return(
            <React.Fragment>
                <Success />
                <Button handleSubmit={submit} />
            </React.Fragment>
        );
        case 400: return(
            <React.Fragment>
                <Error status={status} fields={{name, email, message}}/>
                <Button handleSubmit={submit} />
            </React.Fragment>
        );
        default: return(
            <React.Fragment>
                <Error status={status} />
                <Button handleSubmit={submit} />
             </React.Fragment> 
        )
    }

}

const Contact = () => {
    // const contactRef = useHeaderChecker(CONTACT_MODE);
    const context = useContext(appContext);
    const ref = context.contactRef
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [message, setMessage] = useState("");

    const reset = () => {
        setEmail("");
        setName("");
        setMessage("");
    }
    

    return (
        <div className="contact" ref={ref} id={CONTACT}>
             <div className="header poly">
                <h3>CONTACT</h3>
            </div>
            <TextInput value={name} setValue={setName}>name</TextInput>
            <TextInput value={email} setValue={setEmail}>eMail</TextInput>
            <TextAreaInput value={message} setValue={setMessage}>mESSage</TextAreaInput>
            <Submit data={{email, name, message}} handleReset={reset}/>
        </div>
    )
}

export default Contact
